import { useMemo } from "react";

export default function useRandomItems<T>(items: T[], count?: number): T[] {
    return useMemo(
        () => [...items]
            .sort(() => Math.random() - 0.5)
            .slice(0, count || items.length),
        [items, count]
    );
}